import clsx from "clsx";
import React, { ReactNode } from "react";

import Wrapper from "~/shared/ui/Wrapper";

import s from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/EmployeeProfileForm.less";

interface IFormFieldProps {
  label?: string;
  children: ReactNode;
  className?: string;
  error?: string;
  required?: boolean;
}

const FormField = ({
  label,
  children,
  className,
  error,
  required,
}: IFormFieldProps) => (
  <Wrapper.Field
    label={label}
    labelClassName={s.fieldLabel}
    className={clsx(s.formField, className)}
    required={required}
  >
    {children}
    {error && <div className={s.fieldError}>{error}</div>}
  </Wrapper.Field>
);

export default FormField;
